module.exports = __webpack_public_path__ + "static/media/featuredLogo4.d5052797.png";